/** Pure so it can be tested without i18next: the caller passes `i18n.exists`. */
export function resolveApiErrorKey(code: string | undefined, exists: (key: string) => boolean): string | null {
	if (!code) return null;
	const key = `errors.api.${code}`;
	return exists(key) ? key : null;
}
